import styles from "./SideBar.module.css"
import { NavLink } from "react-router-dom";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import React, {useEffect, useState} from "react";
import { SideBarData, SageNavItem } from "./SideBarData";
import {useLightMode} from "../context/ThemeContext";
import {useFeature} from "../context/FeatureFlagContext";
import {NAV_ACTIVE_LINE} from "./VideoChatPanel";
import {genreLabelFor} from "../utilities/genreIcons";

export default function SideBar({open, setOpen}) {
    let userJSON = JSON.parse(sessionStorage.getItem('user'));
    const {lightMode, genre} = useLightMode();
    // Sage is Dragonlord-tier only. SideBarData is filtered at import time off the
    // sessionStorage roles, which can't see the tier — so gate it here instead.
    const sageEnabled = useFeature('SAGE');
    const navOpen = localStorage.getItem("navOpen_" + userJSON.username) || "true";
    const [navWidth, setNavWidth] = useState(navOpen === 'true' ? "200px" : "60px");

    useEffect(() => {
        localStorage.setItem("navOpen_" + userJSON.username, open)
    }, [open])

    const toggleOpen = () => {
        setOpen(!open);
        if (open) {
            setNavWidth("60px");
        } else {
            setNavWidth("200px");
        }
    }

    const activeState = ({ isActive }) => {
        if (lightMode) {
            return {
                backgroundColor: isActive ? "var(--th-6c4f9b)" : "",
                color: isActive ? "#F5F5F5" : "",
                overflow: "hidden",
                flexWrap: "nowrap",
                width: navWidth,
            };
        }
        return {
            color: isActive ? "var(--th-6c4f9b)" : "",
            // Shared with the video chat dock's bottom border, which lines up with this.
            borderBottom: isActive ? NAV_ACTIVE_LINE : "",
            overflow: "hidden",
            flexWrap: "nowrap",
            width: navWidth,
        };
    };

    const itemText = item => (item.genreLabel && genreLabelFor(item.genreLabel, genre)) || item.text;

    const renderItem = item => (
        <NavLink key={item.id} className={styles.sideitem} to={item.link} style={activeState}
                 data-toggle="tooltip" data-placement="right" title={open ? "" : itemText(item)}>
            <span className={styles.linkIcon}>
                {item.icon}
            </span>
            <span className={styles.linkText}>
                {itemText(item)}
            </span>
        </NavLink>
    );

    // Hoard is always pinned to the bottom group, directly above Sage when Sage is on.
    const mainItems = SideBarData.filter(item => item.link !== '/hoard');
    const hoardItem = SideBarData.find(item => item.link === '/hoard');

    return (
        <div data-sidenav className={open ? styles.sidenav : styles.sidenavClosed}>
            {mainItems.map(renderItem)}
            {(hoardItem || sageEnabled) && (
                <div style={{marginTop: 'auto', paddingBottom: '48px'}}>
                    {hoardItem && renderItem(hoardItem)}
                    {sageEnabled && renderItem(SageNavItem)}
                </div>
            )}
            <div className={styles.expanderButtonContainer}>
                <button className={styles.menuBtn} onClick={toggleOpen}>
                    {open ? <KeyboardDoubleArrowLeftIcon/> : <KeyboardDoubleArrowRightIcon/>}
                </button>
            </div>
        </div>
    )
}